// extracted by mini-css-extract-plugin
export default {"content":"style_content__iP7Is","profileCard":"style_profileCard__k9iEN"};